##
# To learn more about Link Resolving check out the Prismic documentation
# https://prismic.io/docs/vuejs/beyond-the-api/link-resolving
##

export default (doc) -> 
    if doc.isBroken then '/not-found'
    else if doc.type is 'page' then  '/' + doc.uid
    else if doc.type is 'article' then '/artikel/' + doc.uid
    else '/not-found'